<template>
  <div class="details" :class="{ active: active }">
    <div class="overlay" @click="close"></div>
    <div class="content row">
      <div class="img sm-12 md-5 mb-3">
        <a :href="itinerary.image" target="_blank">
          <img :src="itinerary.image" alt="" />
        </a>
      </div>
      <div class="data p-3 pt-0">
        <section class="card meta mb-3">
          <div class="card-content">
            <h2 class="title">{{ itinerary.title }}</h2>
            <h4 class="sub-title">{{ itinerary.subtitle }}</h4>
          </div>
        </section>

        <section class="card mb-3">
          <header class="text-center">
            <h2 class="card-title">Contact Us</h2>
          </header>
          <div class="card-content row pt-2">
            <div>
              <p>Mobile</p>
              <a :href="`tel://${contact.phone}`">{{ contact.phone }}</a>
            </div>
            <div class="spacer"></div>
            <div class="text-right">
              <p>Email</p>
              <a :href="`mailto://${contact.email}`">{{ contact.email }}</a>
            </div>
          </div>
        </section>

        <section class="text-center">
          <button @click="close">back</button>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ItineraryDetails",
  props: {
    itinerary: {
      type: Object,
      required: true,
    },
    active: {
      type: Boolean,
      default: true,
    },
    contact: {
      type: Object,
      default: () => ({
        email: "kuriotravel@gmail.com",
        phone: "+254732313569",
      }),
    },
  },
  data() {
    return {};
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.details {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  pointer-events: none;
  transition: $transition-mid-in-out;

  .overlay {
    transition: inherit;
    background-color: transparent;

    @supports ((backdrop-filter: blur(20px))) {
      backdrop-filter: blur(0px);
    }
  }

  .content {
    position: absolute;
    left: 50%;
    top: 50%;
    width: calc(100% - 2rem);
    max-width: 800px;
    max-height: calc(100vh - 2rem);
    overflow-y: auto;
    overscroll-behavior: none;
    transform: translate(-50%, -50%) scale(0.9);
    transition: inherit;
    opacity: 0;

    .img {
      max-height: 630px;

      img {
        object-fit: contain;
        border-radius: 10px;
      }
    }

    .data {
      flex: 1;

      .meta {
        h4 {
          margin-top: 0;
          opacity: 0.7;
          font-weight: normal;
        }
      }
    }

    @media only screen and (max-width: $breakpoint-mobile) {
      // max-height: calc(100vh - 2rem);

      .data {
        padding: 0 !important;
      }
    }
  }

  &.active {
    pointer-events: all;

    .overlay {
      background-color: #000000a9;

      @supports ((backdrop-filter: blur(20px))) {
        backdrop-filter: blur(8px);
      }
    }

    .content {
      opacity: 1;
      transform: translate(-50%, -50%) scale(1);
    }
  }
}
</style>